import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Initialize the app immediately with native auth
createApp(App)
    .use(router)
    .mount('#app')

// Register Service Worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(() => {
                // ServiceWorker registered
            })
            .catch(() => {
                // ServiceWorker registration failed
            });
    });
}
